export const verifyRole = (role = '') => {
  if (role === 'Admin' || role === 'Admin - Capital') {
    return true;
  } else {
    return false;
  }
};

export const camelCaseToTitleCase = (camelCase: any) => {
  if (camelCase === null || camelCase === '') {
    return camelCase;
  }
  camelCase = camelCase.trim();
  var newText = '';
  for (var i = 0; i < camelCase.length; i++) {
    if (/[A-Z]/.test(camelCase[i]) && i !== 0 && /[a-z]/.test(camelCase[i - 1])) {
      newText += ' ';
    }
    if (i === 0 && /[a-z]/.test(camelCase[i])) {
      newText += camelCase[i].toUpperCase();
    } else {
      newText += camelCase[i];
    }
  }
  return newText;
};

//get rid of __typename from graphql object
export const stripTypenames = (value) => {
  if (value !== null && typeof value === 'object') {
    const newObject = {};
    for (const property in value) {
      if (property !== '__typename') {
        newObject[property] = stripTypenames(value[property]);
      }
    }
    return newObject;
  } else {
    return value;
  }
};